import { render, staticRenderFns } from "./biyeAuditBzr.vue?vue&type=template&id=6a367072&scoped=true"
import script from "./biyeAuditBzr.vue?vue&type=script&lang=js"
export * from "./biyeAuditBzr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a367072",
  null
  
)

export default component.exports